import { useTheme } from '@mui/material';
import { CmsBlockHeights } from '@/services/cms/models/CmsBlockHeights';

export const useResolveBlockHeight = (height?: CmsBlockHeights) => {
    const theme = useTheme();
    switch (height) {
        case 'Large':
            return `${theme.settings.bannerHeights.large}px`;
        case 'Medium':
            return `${theme.settings.bannerHeights.medium}px`;
        case 'Small':
            return `${theme.settings.bannerHeights.small}px`;
    }
    return 'auto';
};
